import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 英文包装种类分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemPackageEn extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 英文名称
     */
    Name?: string;
    /**
     * 英文简写
     */
    Abbr?: string;
    /**
     * 海关代码
     */
    Code?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 英文包装种类分页列表-项-表单校验
 */
export const DtoListItemPackageEnRules = {
}

/**
 * 英文包装种类分页列表-项-设置项
 */
export const DtoListItemPackageEnMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Name",
    Label: "英文名称",
  },
  {
    Prop: "Abbr",
    Label: "英文简写",
  },
  {
    Prop: "Code",
    Label: "海关代码",
  },
]
